module.exports = __webpack_public_path__ + "static/policy_book2_1@2x-5ca56c21b3479cc51ab0b87e6e5269aa.png";